import type { CSSProperties } from "react";

/**
 * Carbonsix logo glyph (StrokeDrawLogo path from
 * sigmakit-gui/src/renderer/app/bootstrap/StartLoadingLayout). Single-color icon —
 * fill follows `currentColor`. Native art box is 635×581.
 */

export const CARBONSIX_W = 635;
export const CARBONSIX_H = 581;
export const CARBONSIX_INNER = "translate(0,581) scale(0.1,-0.1)";
export const CARBONSIX_PATHS = [
  "M1618 5656 c-49 -79 -88 -149 -88 -156 0 -6 300 -507 666 -1112 366 -606 668 -1107 671 -1113 2 -7 -329 -570 -735 -1252 -407 -682 -745 -1250 -751 -1262 -11 -19 11 -59 209 -386 l222 -365 1462 0 1461 0 175 291 c96 161 177 296 178 300 2 5 -675 9 -1533 9 -1226 0 -1536 3 -1532 12 3 7 361 604 796 1327 436 722 790 1320 787 1327 -3 8 -264 442 -581 965 -316 522 -575 953 -575 955 0 3 610 4 1355 2 745 -2 1355 -1 1355 1 0 2 -82 138 -182 302 l-181 299 -1546 0 -1546 0 -87 -144z",
  "M1328 5174 c-72 -114 -1302 -2152 -1310 -2170 -8 -18 79 -169 578 -995 323 -536 592 -980 599 -987 9 -10 46 44 178 267 l166 279 -430 710 -430 710 499 824 c274 452 504 833 510 845 11 20 -4 47 -149 275 -89 139 -167 259 -174 267 -11 11 -17 7 -37 -25z",
  "M3955 3263 l-50 -4 -161 -277 -161 -277 1048 -3 c577 -1 1049 -4 1049 -6 0 -3 -1002 -1677 -1077 -1798 -2 -5 146 -8 329 -8 l333 1 542 896 541 895 -176 294 -177 293 -995 -1 c-547 -1 -1017 -3 -1045 -5z",
];

export interface CarbonsixIconProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function CarbonsixIcon({ size = 24, className, style }: CarbonsixIconProps) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={(size * CARBONSIX_H) / CARBONSIX_W}
      viewBox={`0 0 ${CARBONSIX_W} ${CARBONSIX_H}`}
      role="img"
      aria-label="Carbonsix"
    >
      <g transform={CARBONSIX_INNER} fill="currentColor">
        {CARBONSIX_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
    </svg>
  );
}

CarbonsixIcon.displayName = "CarbonsixIcon";
